<template>
	<div class="template contact select">
		<div class="panel_wrap">
			<label class="panel_title">{{ dataVal.Property.Title[0].Text
        }}<span v-show="dataVal.Property.Require == 1"
				 class="require">*</span>
			</label>
			<div class="input_value" :style="
          dataVal.Property.Title[0].Text.length == 4
            ? 'max-width:calc(100% - 67px);'
            : ''
        ">
				<!-- <Select filterable remote clearable :loading="loading" :remote-method="remoteMethod" v-bind:disabled="dataVal.Disable"
				 v-model="dataVal.Value" @on-change="changeVal(dataVal.Property.Title[0].Text)">
					<Option v-for="item in dataVal.Options" :value="item.Value" :key="item.Key">{{ item.Value}}</Option>
				</Select> -->
				
				<!--  -->
				<el-select size="mini" filterable remote :remote-method="remoteMethod"  clearable :loading="loading"  :disabled="dataVal.Disable"
				 ref='selectComponents' v-model="dataVal.Value" @change="changeVal(dataVal.Property.Title[0].Text)" @hook:mounted="cancalReadOnly"
				 @visible-change='cancalReadOnly'>
					<el-option v-for="item in dataVal.Options" :key="item.Key" :label="item.Value" :value="item.Value">
					</el-option>
				</el-select>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getDepartmentList
	} from "@/api/department";
	import {
		getAdministrativeProgressive
	} from "@/api/approval";
	export default {
		props: ["dataVal", "templateData", "dataValue"],
		data() {
			return {
				page: 1,
				size: 10,
				querys: null,
				loading: false,
			};
		},
		mounted() {
			// if(this.dataVal.Property.Title[0].Text == "物品名称"){
			// 	console.log(this.dataVal)
			// }
			// console.log(this.dataVal)
		},

		methods: {
			cancalReadOnly(onOff) {
				this.$nextTick(() => {
					if (!onOff) {
						const {
							selectComponents
						} = this.$refs;
						const input = selectComponents.$el.querySelector('.el-input__inner');
						input.removeAttribute('readonly');
					}
				});
			},
			changeVal: async function(name) {
				// console.log(name)
				var data = this.dataValue.filter((t) => {
					return t.Property.Title[0].Text == name;
				})[0].Value;
				var val = null;
				var type = "";
				var ItemName = "";
				var SpecificationModel = "";
				var Company = "";
				var UnitPrice = "";
				var QueryType = 0;

				if (this.dataVal.Property.Title[0].Text == "种类") {
					type = data;
					QueryType = 2;
					this.dataValue.filter((t) => {
						return t.Property.Title[0].Text == "物品名称";
					})[0].Value = "";
					this.dataValue.filter((t) => {
						return t.Property.Title[0].Text == "规格型号";
					})[0].Value = "";
					this.dataValue.filter((t) => {
						return t.Property.Title[0].Text == "单位";
					})[0].Value = "";
					this.dataValue.filter((t) => {
						return t.Property.Title[0].Text == "单价";
					})[0].Value = "";
				}
				if (this.dataVal.Property.Title[0].Text == "物品名称") {
					QueryType = 3;
					ItemName = data;
					type = this.dataValue.filter((t) => {
						return t.Property.Title[0].Text == "种类";
					})[0].Value;
					this.dataValue.filter((t) => {
						return t.Property.Title[0].Text == "规格型号";
					})[0].Value = "";
					this.dataValue.filter((t) => {
						return t.Property.Title[0].Text == "单位";
					})[0].Value = "";
					this.dataValue.filter((t) => {
						return t.Property.Title[0].Text == "单价";
					})[0].Value = "";
				}
				if (this.dataVal.Property.Title[0].Text == "规格型号") {
					QueryType = 4;
					SpecificationModel = data;
					type = this.dataValue.filter((t) => {
						return t.Property.Title[0].Text == "种类";
					})[0].Value;
					ItemName = this.dataValue.filter((t) => {
						return t.Property.Title[0].Text == "物品名称";
					})[0].Value;
					this.dataValue.filter((t) => {
						return t.Property.Title[0].Text == "单位";
					})[0].Value = "";
					this.dataValue.filter((t) => {
						return t.Property.Title[0].Text == "单价";
					})[0].Value = "";
				}
				if (this.dataVal.Property.Title[0].Text == "单位") {
					QueryType = 5;
					Company = data;
					type = this.dataValue.filter((t) => {
						return t.Property.Title[0].Text == "种类";
					})[0].Value;
					ItemName = this.dataValue.filter((t) => {
						return t.Property.Title[0].Text == "物品名称";
					})[0].Value;
					SpecificationModel = this.dataValue.filter((t) => {
						return t.Property.Title[0].Text == "规格型号";
					})[0].Value;
					this.dataValue.filter((t) => {
						return t.Property.Title[0].Text == "单价";
					})[0].Value = "";
				}
				
				this.loading = true;
				this.queryRequest(data,type,ItemName,SpecificationModel,Company,UnitPrice,QueryType)
				
				
				// await getAdministrativeProgressive(
				// 	type,
				// 	ItemName,
				// 	//SpecificationModel,
				// 	SpecificationModel.replace(/\+/g, '%2B'),
				// 	Company,
				// 	UnitPrice,
				// 	QueryType
				// ).then((res) => {
				// 	this.dataValue.forEach((sonData,idx) => {

				// 		if (sonData.Property.Title[0].Text == "物品名称" && QueryType == 2) {
				// 			this.$set(sonData, "Options", []);
				// 			res.Body.forEach((item, index) => {
				// 				var data = {
				// 					Key: item,
				// 					Value: item,
				// 				};
				// 				sonData.Options.push(data);
				// 			});
				// 			if (res.Body.length == 1) {
				// 				sonData.Value = res.Body[0];
				// 			}
				// 		} else if (
				// 			sonData.Property.Title[0].Text == "规格型号" &&
				// 			QueryType == 3
				// 		) {
				// 			this.$set(sonData, "Options", []);
				// 			res.Body.forEach((item) => {
				// 				var data = {
				// 					Key: item,
				// 					Value: item,
				// 				};
				// 				sonData.Options.push(data);
				// 			});
				// 			if (res.Body.length == 1) {
				// 				sonData.Value = res.Body[0];
				// 			}
				// 		} else if (
				// 			sonData.Property.Title[0].Text == "单位" &&
				// 			QueryType == 4
				// 		) {
				// 			this.$set(sonData, "Options", []);
				// 			res.Body.forEach((item) => {
				// 				var data = {
				// 					Key: item,
				// 					Value: item,
				// 				};
				// 				sonData.Options.push(data);
				// 			});
				// 			if (res.Body.length == 1) {
				// 				sonData.Value = res.Body[0];
				// 			}
				// 		} else if (
				// 			sonData.Property.Title[0].Text == "单价" &&
				// 			QueryType == 5
				// 		) {
				// 			this.$set(sonData, "Options", []);
				// 			res.Body.forEach((item) => {
				// 				var data = {
				// 					Key: item,
				// 					Value: item,
				// 				};
				// 				sonData.Options.push(data);
				// 			});
				// 			if (res.Body.length == 1) {
				// 				sonData.Value = res.Body[0];
				// 			}
				// 		}
				// 		this.loading = false;
				// 	});
				// 	this.$forceUpdate();
				// 	// console.log(this.dataVal);
				// });
				this.$forceUpdate()
				this.$emit("child-event", val, name, this.dataVal);
			},
			queryRequest:async function(data,type,ItemName,SpecificationModel,Company,UnitPrice,QueryType){
				
				await getAdministrativeProgressive(
					type,
					ItemName,
					// SpecificationModel,
					SpecificationModel.replace(/\+/g, '%2B'),
					Company,
					UnitPrice,
					QueryType
				).then(res =>{
					this.dataValue.forEach((sonData,idx) => {
						if (sonData.Property.Title[0].Text == "物品名称" && QueryType == 2) {
							this.$set(sonData, "Options", []);
							res.Body.forEach((item, index) => {
								var data = {
									Key: item,
									Value: item,
								};
								sonData.Options.push(data);
							});
							if (res.Body.length == 1) {
								sonData.Value = res.Body[0];
								if(data){
									this.queryRequest(res.Body[0],type,ItemName,sonData.Options.Value,Company,UnitPrice,3)
								}else{
									sonData.Value = '';
								}
							}
						} else if ( sonData.Property.Title[0].Text == "规格型号" && QueryType == 3 ) {
							this.$set(sonData, "Options", []);
							res.Body.forEach((item) => {
								var data = {
									Key: item,
									Value: item,
								};
								sonData.Options.push(data);
							});
							if (res.Body.length == 1) {
								sonData.Value = res.Body[0];
								if(data){
									this.queryRequest(res.Body[0],type,ItemName,SpecificationModel,sonData.Options.Value,UnitPrice,4)
								}else{
									sonData.Value = '';
								}
							}
							// console.log(sonData)
						} else if ( sonData.Property.Title[0].Text == "单位" && QueryType == 4 ) {
							this.$set(sonData, "Options", []);
							res.Body.forEach((item) => {
								var data = {
									Key: item,
									Value: item,
								};
								sonData.Options.push(data);
							});
							if (res.Body.length == 1) {
								sonData.Value = res.Body[0];
								if(data){
									this.queryRequest(res.Body[0],type,ItemName,SpecificationModel,Company,sonData.Options.Value,5)
								}else{
									sonData.Value = '';
								}
								
							}
						} else if ( sonData.Property.Title[0].Text == "单价" && QueryType == 5) {
							this.$set(sonData, "Options", []);
							res.Body.forEach((item) => {
								var data = {
									Key: item,
									Value: item,
								};
								sonData.Options.push(data);
							});
							if (res.Body.length == 1) {
								sonData.Value = res.Body[0];
								if(!data){
									sonData.Value = '';
								}
							}
						}
						this.loading = false;
						this.$forceUpdate();
					});
					
				})
			},
			
			remoteMethod(query) {},
		},
	};
</script>
<style>
	@import "../assets/css/common.css";

	.ivu-select-selection {
		border: none !important;
	}

	.ivu-select-single .ivu-select-selection {
		height: 24px !important;
	}

	.ivu-select-single .ivu-select-selection .ivu-select-placeholder,
	.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
		height: 24px !important;
		line-height: 24px !important;
	}

	.ivu-select-dropdown-list {
		text-align: left !important;
		opacity: 1;
	}

	.select .input_value {
		height: auto !important;
		line-height: 24px !important;
	}

	.ivu-select-multiple .ivu-tag {
		max-width: 98% !important;
		overflow: hidden !important;
		white-space: nowrap !important;
		text-overflow: ellipsis !important;
	}
</style>
